export default __webpack_public_path__ + "static/media/project_ollivanders.96df65e7.png";